// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';

import { TypeSensorVariableDO, VariableDO } from '../../../requests';

interface Props {
  formValues: {
    variableArray: VariableDO[];
    data: Partial<TypeSensorVariableDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { variableArray, data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Variable</b> &nbsp;
          </label>
          <Select2
            name="variable.id"
            data={variableArray.map((item: VariableDO): DataSelect2 => {
              return { id: item.id, text: item.name };
            })}
            value={(data.variable && data.variable.id) || ''}
            options={{
              placeholder: 'Select option',
            }}
            onChange={props.onChange}
            style={{ width: '80%' }}
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Order</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.order || ''}
            name="order"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Bytes</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.bytes || '0'}
            name="bytes"
            onChange={props.onChange}
            min="0"
            pattern="[0-9]+"
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Formula</b> &nbsp; <br />
            Use a dollar symbol followed by the letter B and a number to use the value of a byte. <br />
            Example: $B0*256+$B1
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.formula || ''}
            name="formula"
            onChange={props.onChange}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Adjust if less than:</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.adjustMin || (data.adjustMin === 0 ? 0 : '')}
            name="adjustMin"
            onChange={props.onChange}
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Adjust if greater than:</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.adjustMax || (data.adjustMax === 0 ? 0 : '')}
            name="adjustMax"
            onChange={props.onChange}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Discard if less than:</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.discardMin || (data.discardMin === 0 ? 0 : '')}
            name="discardMin"
            onChange={props.onChange}
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Discard if greater than:</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data.discardMax || (data.discardMax === 0 ? 0 : '')}
            name="discardMax"
            onChange={props.onChange}
          />
        </div>
      </div>
    </fieldset>
  );
}
